import { outreach } from '@round/api';

export const ALL_TAB = 'all';

export type OutreachResultsTab = typeof ALL_TAB | outreach.OutreachResultStatus;

const TABS: OutreachResultsTab[] = [ALL_TAB, 'TO_REVIEW', 'ADDED', 'ARCHIVED'];

/** The set the client still has to go through, which is what the band opens on. */
export const DEFAULT_TAB: OutreachResultsTab = 'TO_REVIEW';

const isTab = (value: string): value is OutreachResultsTab => TABS.includes(value as OutreachResultsTab);

export const parseTab = (value: string | undefined): OutreachResultsTab =>
    value && isTab(value) ? value : DEFAULT_TAB;

/** `all` is the absence of the filter rather than a status the endpoint knows. */
export const getStatusParam = (tab: OutreachResultsTab): string | undefined => (tab === ALL_TAB ? undefined : tab);

export type OutreachResultsTabItem = {
    value: OutreachResultsTab;
    label: string;
    count: number;
};

/** The counts come off the request: the pages loaded lag the results still streaming in. */
export const getTabItems = (request: outreach.OutreachRequest): OutreachResultsTabItem[] => [
    { value: ALL_TAB, label: 'All', count: request.results_count },
    { value: 'TO_REVIEW', label: 'To review', count: request.to_review_count },
    { value: 'ADDED', label: 'Added', count: request.added_count },
    { value: 'ARCHIVED', label: 'Archived', count: request.archived_count },
];
